












































import { Mixins, Component, Prop } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';

type Group = I.AxZone;

interface Zone {
  name: string;
}

@Component
export default class AxTempGeneralHistoryDialog extends Mixins(AxPage) {
  on = true;
  width = 450;
  height = 630;

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '구역 선택' })
  title!: string;

  @Prop({ type: Boolean, default: false })
  single!: boolean;

  @Prop({ type: String, default: 'loginid' })
  itemKey!: string;

  @Prop({ type: Boolean, default: true })
  showSelect!: boolean;

  async prepare() {
    if (this.param) {
    }
    console.log('start', this.param);
  }

  onDialogRowClicked(item: I.MonitorAccount) {
    this.param.selected = [item];
  }

  onDialogSelected() {
    this.param.callback();
    this.$emit('changed', this.on);
  }
}
